import apiClient from '../axios';
import { Credentials } from './interfaces';

export const login = async (credentials: Credentials): Promise<void> => {
  await apiClient.post('/login', JSON.stringify(credentials), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const logout = async (): Promise<void> => {
  await apiClient.post('/logout', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const initCsrfCookie = async (): Promise<void> => {
  await apiClient.get('/sanctum/csrf-cookie');
};
